import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';

import { Observable, tap } from 'rxjs';

import { ENTRYPOINT } from '../enpoint';

export interface AppConfig {
  max_area: number;
}
const CONFIG_API = `${ENTRYPOINT}/api/config/`;
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  #http = inject(HttpClient);
  #configSignal = signal<AppConfig | null>(null);

  readonly config = computed(() => this.#configSignal());

  loadConfig(): Observable<AppConfig> {
    return this.#http.get<AppConfig>(CONFIG_API).pipe(
      tap((config) => {
        this.#configSignal.set(config);
      }),
    );
  }
}
